/**
 * schemas/lookup.ts — ค้นหาข้อมูลผู้เสียภาษีจากกรมสรรพากร และรูปแบบผลรายงาน
 */
import { z } from 'zod';
import { requiredTaxId, yearMonthQuery } from './common.js';
export const taxLookupQuery = z.object({
    taxId: requiredTaxId,
});
// ==================== รายงาน ====================
export const reportQuery = yearMonthQuery;
export const monthlySeriesQuery = z.object({
    year: z.coerce.number().int().min(2000).max(2100).optional(),
});
//# sourceMappingURL=lookup.js.map